// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PopupVideo-module-buttonWrapper-3tt5S{align-self:flex-start}.PopupVideo-module-center-3d0KO{align-self:center}.PopupVideo-module-right-17kUe{align-self:flex-end}", ""]);
// Exports
exports.locals = {
	"buttonWrapper": "PopupVideo-module-buttonWrapper-3tt5S",
	"center": "PopupVideo-module-center-3d0KO",
	"right": "PopupVideo-module-right-17kUe"
};
module.exports = exports;
